import React, { useState, useEffect } from "react";
import { Carousel } from "antd";
import cloudImage from "../../asset/newHerobg.png";
import exploreImage from "../../asset/landing_images/landing-frame1.webp";
import jobsImage from "../../asset/landing_images/newJobImg.webp";
import marketplaceImage from "../../asset/landing_images/landing-frame3.webp";
import fourthImage from "../../asset/landing_images/landing-frame5.webp";

const LandingHero = () => {
  // Hero section styles
  const heroSectionStyle = {
    minHeight:window.innerWidth <= 760
    ? "100vh" // Mobile screens
    : window.innerWidth <= 900 // No need to check `> 760` because `<= 760` is already handled
    ? "45vh" // Small tablets
    : "90vh",
    backgroundImage: `url(${cloudImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  };

  const heroContent = {
    position: "absolute",
    padding:'2rem 0',
    // border:"2px solid green",
    width: "100%",
    top:0,
    bottom: 0
  }
  // const heroTextStyle = {
  //   color: "#09839B",
  //   // border:'2px solid red',
  //   padding:'1.5rem 0',
  //   textAlign:'center',
  //   lineHeight:'24px',
  //   fontSize: window.innerWidth <= 768 ? "1.8rem" : "3rem",
  // };

  const pTextStyle = {
    color: "#000",
    padding:'0rem 2rem',
    textAlign:'center',
    fontSize: window.innerWidth <= 768 ? "1rem" : "1.2rem",
  };

  const infoCardsSectionStyle = {
    top: 0,
    // border: "2px solid blue",
    width: "100%",
    margin:'auto 0',
    height:"auto",
    zIndex: 1,
    padding: window.innerWidth <= 768 ? "20px 0" : "2rem 0",
    paddingLeft:window.innerWidth > 900 ?'4rem' : ''
  };

  const cardStyle = {
    transition: "transform 0.3s",
    // border: "2px solid red",
   width:
    window.innerWidth <= 760
    ? "100%" // Mobile screens
    : window.innerWidth <= 810 // No need to check `> 760` because `<= 760` is already handled
    ? "11rem" // Small tablets
    : window.innerWidth <= 1020 // No need to check `> 810`
    ? "12rem" // Larger tablets
    : window.innerWidth <= 1280 ? "15rem"
    : "18rem", // Default for larger screens
    height: window.innerWidth <= 768 ? "100%" : '400px',
    background: "transparent",
    // border: "none",
   
  };

  const handleCardHover = (e) => {
    e.currentTarget.style.transform = "scale(1.05)";
  };

  const handleCardUnhover = (e) => {
    e.currentTarget.style.transform = "scale(1)";
  };

  const infoCards = [
    {
      img: exploreImage,
      
    },
    {
      img: jobsImage,
    },
    {
      img: marketplaceImage,
    },
    {
      img: fourthImage,
    },
  ];

  const [slidesToShow, setSlidesToShow] = useState(1);

  useEffect(() => {
    const updateMedia = () => {
      if (window.innerWidth < 768) {
        setSlidesToShow(1);
      } else {
        setSlidesToShow(4);
      }
    };

    window.addEventListener("resize", updateMedia);
    updateMedia();

    return () => window.removeEventListener("resize", updateMedia);
  }, []);

  return (
    <div id="home">
      {/* Hero Section */}
      <div style={heroSectionStyle}>
        <div style={heroContent}>
          {/* <h3 style={heroTextStyle}>YouthPlus</h3> */}
          <p style={pTextStyle}>Connect, Share, and Grow with Your Community</p>
          <div style={infoCardsSectionStyle}>
          <Carousel
            autoplay
            dots={false}
            slidesToShow={slidesToShow}
            infinite
            effect="scrollx"
          >
            {infoCards.map((card, index) => (
              <div key={index}>
                    <div style={{ ...cardStyle, marginTop: index % 2 === 0 ? "4rem" : "0px", }}
                      onMouseEnter={handleCardHover}
                      onMouseLeave={handleCardUnhover}
                    >
                      <img
                          alt={card.title}
                          src={card.img}
                          style={{
                            width:"100%",
                            height:"auto",
                            objectFit: "cover",
                          }}
                        />
                      
                      {card.title && card.title !== ""?(
                        <div style={{margin:'10px 0px 0 10px'}}>
                          <p style={{  bottom:0, fontWeight:600, fontSize:'1.2rem'}}>{card.title}</p>
                          <p style={{ top:0}}>{card.description}</p>
                        </div>
                        ):''}
                    </div>
              </div>
            ))}
          </Carousel>
        </div>
        </div>
        

        {/* Info Cards Section with Carousel */}
        
      </div>
    </div>
  );
};

export default LandingHero;
